// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.divExternalPage{
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    color: white;
}
.divExternalPageContentTitle{
  display: flex;
  flex-direction: row;
  gap:16px;
  align-items: center;
}
.divExternalPageMenu{
    display: flex;
    flex-direction: column;
    width: 6%;
    background-color: #FFFFFF;
    color: black;
    padding:32px 0 32px 0px ;
  }

.divExternalPageContent{
  display: flex;
  flex-direction: column;
  gap:24px;
  padding:32px 0 0 64px;
  width: 94%;
  background-color: #373737;
  padding-bottom: 100px;
}

.divExternalPageRow{
  display: flex;
  flex-direction: row;
  gap:16px;
}



.divExternalPageFirst{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 16px;
  max-width: 70%;
  border-bottom: solid 1px white;
  gap:16px;
  font-size:32px;
  margin-top:40px;
  cursor: pointer;
}


.divExternalPageTextMedium{
  font-size: 24px;
}


.divExternalPageTextBig{
  font-size: 32px;
}


.divExternalPageIconContent{
  display: flex;
  flex-direction: row;
  gap:8px;
}


.divExternalPageReturnIconImg{
  width: 28px;
  height: auto;
}


.divExternalPageReturnIconImgBig{
  width: 36px;
  height: auto;
}


.divExternalPageReturnContent{
  display: flex;
  gap: 30px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding:10px;
  width: 50%;
  min-width: 500px;
}

.divExternalPageReturnContentText{
  display: flex;
}

.divExternalPageGeral{
  display: flex;
  flex-direction: column;
  gap:16px;
  margin: 10px 0 64px 64px;
}


@media (max-width: 768px) {
  
    .divExternalPage{
      flex-direction: column;
    }
        
    .divExternalPageContentTitle{
      flex-direction: column;
    }
      
       
    .divExternalPageMenu{
        flex-direction: row;
        width: 100%;
        height: 80px;
        padding: 10px;
    }

    .divExternalPageContent{
      padding:10px 0 100px 20px;
      width: 100%;
      min-height: 150vh;
    }

        
    .divExternalPageRow{
      flex-direction: column;
    }

      
    .divExternalPageReturnContent{
      gap: 16px;
      flex-direction: column;
      width: 250px;
      min-width: auto;
    }

    .divExternalPageTextMedium{
      font-size: 18px;
    }
    
    
    .divExternalPageTextBig{
      font-size: 24px;
    }
    

      
    .divExternalPageGeral{
      margin: 5px 0 16px 16px;
    }
                            
    

  .divExternalPageReturnIconImgBig{
    width: 28px;
  }

    

  .divExternalPageFirst{
    max-width: 100%;
    font-size:24px;
    margin-top:30px;
  }

}  `, "",{"version":3,"sources":["webpack://./src/pages/ContentExternalPage/contentExternalPage.css"],"names":[],"mappings":";AACA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;EAC1B;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;AACT;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wBAAwB;AAC1B;;;AAGA;;IAEI;MACE,sBAAsB;IACxB;;IAEA;MACE,sBAAsB;IACxB;;;IAGA;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;MACE,yBAAyB;MACzB,WAAW;MACX,iBAAiB;IACnB;;;IAGA;MACE,sBAAsB;IACxB;;;IAGA;MACE,SAAS;MACT,sBAAsB;MACtB,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;;IAGA;MACE,eAAe;IACjB;;;;IAIA;MACE,uBAAuB;IACzB;;;;EAIF;IACE,WAAW;EACb;;;;EAIA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;AAEF","sourcesContent":["\n.divExternalPage{\n    min-height: 100vh;\n    display: flex;\n    flex-direction: row;\n    color: white;\n}\n.divExternalPageContentTitle{\n  display: flex;\n  flex-direction: row;\n  gap:16px;\n  align-items: center;\n}\n.divExternalPageMenu{\n    display: flex;\n    flex-direction: column;\n    width: 6%;\n    background-color: #FFFFFF;\n    color: black;\n    padding:32px 0 32px 0px ;\n  }\n\n.divExternalPageContent{\n  display: flex;\n  flex-direction: column;\n  gap:24px;\n  padding:32px 0 0 64px;\n  width: 94%;\n  background-color: #373737;\n  padding-bottom: 100px;\n}\n\n.divExternalPageRow{\n  display: flex;\n  flex-direction: row;\n  gap:16px;\n}\n\n\n\n.divExternalPageFirst{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-bottom: 16px;\n  max-width: 70%;\n  border-bottom: solid 1px white;\n  gap:16px;\n  font-size:32px;\n  margin-top:40px;\n  cursor: pointer;\n}\n\n\n.divExternalPageTextMedium{\n  font-size: 24px;\n}\n\n\n.divExternalPageTextBig{\n  font-size: 32px;\n}\n\n\n.divExternalPageIconContent{\n  display: flex;\n  flex-direction: row;\n  gap:8px;\n}\n\n\n.divExternalPageReturnIconImg{\n  width: 28px;\n  height: auto;\n}\n\n\n.divExternalPageReturnIconImgBig{\n  width: 36px;\n  height: auto;\n}\n\n\n.divExternalPageReturnContent{\n  display: flex;\n  gap: 30px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding:10px;\n  width: 50%;\n  min-width: 500px;\n}\n\n.divExternalPageReturnContentText{\n  display: flex;\n}\n\n.divExternalPageGeral{\n  display: flex;\n  flex-direction: column;\n  gap:16px;\n  margin: 10px 0 64px 64px;\n}\n\n\n@media (max-width: 768px) {\n  \n    .divExternalPage{\n      flex-direction: column;\n    }\n        \n    .divExternalPageContentTitle{\n      flex-direction: column;\n    }\n      \n       \n    .divExternalPageMenu{\n        flex-direction: row;\n        width: 100%;\n        height: 80px;\n        padding: 10px;\n    }\n\n    .divExternalPageContent{\n      padding:10px 0 100px 20px;\n      width: 100%;\n      min-height: 150vh;\n    }\n\n        \n    .divExternalPageRow{\n      flex-direction: column;\n    }\n\n      \n    .divExternalPageReturnContent{\n      gap: 16px;\n      flex-direction: column;\n      width: 250px;\n      min-width: auto;\n    }\n\n    .divExternalPageTextMedium{\n      font-size: 18px;\n    }\n    \n    \n    .divExternalPageTextBig{\n      font-size: 24px;\n    }\n    \n\n      \n    .divExternalPageGeral{\n      margin: 5px 0 16px 16px;\n    }\n                            \n    \n\n  .divExternalPageReturnIconImgBig{\n    width: 28px;\n  }\n\n    \n\n  .divExternalPageFirst{\n    max-width: 100%;\n    font-size:24px;\n    margin-top:30px;\n  }\n\n}  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
